import { z } from "zod";
export const importStatusSchema = z.enum(["uploaded", "mapped", "committed", "failed"]);
export const importColumnMappingSchema = z.record(z.string());
export const importSummarySchema = z.object({
    created: z.number().int().nonnegative(),
    updated: z.number().int().nonnegative(),
    skipped: z.number().int().nonnegative(),
    errors: z
        .array(z.object({
        row: z.number().int().nonnegative(),
        message: z.string(),
    }))
        .default([]),
});
export const importSchema = z.object({
    id: z.string(),
    filename: z.string(),
    status: importStatusSchema,
    columnMapping: importColumnMappingSchema.nullable(),
    summary: importSummarySchema.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const importMappingBodySchema = z.object({
    columnMapping: importColumnMappingSchema,
});
/**
 * A single mapped row posted to POST /imports. `rowNumber` is the source
 * row in the user's file (1-based, header = row 1) so per-row errors in the
 * summary can point the user back at the offending line. `data` is a loosely
 * typed contact payload validated server-side against contactInputSchema.
 */
export const importRowSchema = z.object({
    rowNumber: z.number().int().nonnegative(),
    data: z.record(z.unknown()),
});
/**
 * Body for POST /imports. Parsing/header-detection/mapping happen client-side
 * (see docs/api.md "Import"); the client posts the already-mapped rows here.
 */
export const importCommitBodySchema = z.object({
    filename: z.string().min(1).max(500),
    columnMapping: importColumnMappingSchema,
    rows: z.array(importRowSchema).min(1).max(5000),
});
//# sourceMappingURL=import.js.map